import { styled } from '@project44/manifest-ds';

import mapSkeleton from '../../../../assets/mapSkeleton.png';
import { SKELETON_BASE } from '../../../../utils/constants/SKELETON_BASE';

export const MapBoxSkeleton = styled('div', {
  backgroundImage: `url(${mapSkeleton})`,
  backgroundSize: 'cover',
  position: 'absolute',
  top: '65px',
  left: '0',
  right: '0',
  bottom: '0',
  borderRadius: '0',
});

export const MapTitleSkeleton = styled('div', {
  ...SKELETON_BASE,
  position: 'absolute',
  top: '20px',
  left: '20px',
  width: '200px',
  height: '30px',
});

export const StyledMapSkeleton = styled('div', {
  position: 'relative',
  height: '100%',
  width: '100%',
});
